var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.zoomCss),attrs:{"id":"app"},on:{"click":_vm.handleClickRead}},[_c('bank-header',{attrs:{"isBig":_vm.isBig},on:{"toggle-big":_vm.changeSize}}),_c('div',{staticClass:"v-view"},[_c('router-view')],1),_c('bank-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }